// extracted by mini-css-extract-plugin
export default {"ghost-indicator":"ghost-indicator--WSUP-JcZo9","ghostIndicator":"ghost-indicator--WSUP-JcZo9"};